import { render, staticRenderFns } from "./ShopIntroSection.vue?vue&type=template&id=3fb6aaac&"
import script from "./ShopIntroSection.vue?vue&type=script&lang=js&"
export * from "./ShopIntroSection.vue?vue&type=script&lang=js&"
import style0 from "./ShopIntroSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports